import React from 'react';
import style from './RelatedSitesLinks.scss';
import classnames from 'classnames';
import { ExternalLink } from '../../../PageElements/ExternalLink';

export const RelatedSitesLinks = ({
  links,
  sendBiEventWhenClickOnRelatedSite,
}) => {
  return links.map(({ name, url, active }) => (
    <ExternalLink
      key={name}
      to={url}
      className={classnames({
        [style.headerLink]: true,
        [style.active]: active,
      })}
      link={false}
      target="_self"
      onClick={() => sendBiEventWhenClickOnRelatedSite(name, url)}
      data-active={`${active}`}
      size="small"
      weight="thin"
    >
      {name}
    </ExternalLink>
  ));
};
